import { useToastController } from '@tamagui/toast';
import {
    FileBoxIcon,
    FileCogIcon,
    FileIcon,
    FileStackIcon,
} from 'lucide-react-native';
import { View, XStack, YStack } from 'tamagui';

import {
    Button,
    ButtonSize,
    ButtonVariant,
} from '../../components/buttons/Button';
import { TileButton } from '../../components/buttons/TileButton';
import { Icon } from '../../components/icons/Icon';
import { BodySmallRegular } from '../../components/text/Typography';

export const Toasts = () => {
    const toast = useToastController();
    return (
        <YStack gap={16}>
            <BodySmallRegular>
                These use an extended duration. The default is quite quick.
            </BodySmallRegular>
            <YStack gap={16} marginHorizontal={30}>
                <XStack gap={16} height={60}>
                    <TileButton
                        text="Show basic toast"
                        icon={FileIcon}
                        onPress={() => {
                            toast.show('Toast is done!', { duration: 10000 });
                        }}
                    />
                    <TileButton
                        text="Show icon toast"
                        icon={FileBoxIcon}
                        onPress={() => {
                            toast.show('Toast with butter is done!', {
                                // Toast with icon
                                icon: (
                                    <View
                                        padding={12}
                                        backgroundColor="$gray100"
                                        borderRadius={8}
                                    >
                                        <Icon
                                            icon={FileBoxIcon}
                                            size={24}
                                            color="$gray1200"
                                        />
                                    </View>
                                ),
                                duration: 10000,
                            });
                        }}
                    />
                </XStack>
                <XStack gap={16} height={60}>
                    <TileButton
                        text="Show 2-ine toast"
                        icon={FileStackIcon}
                        onPress={() => {
                            toast.show('Toast is done!', {
                                description: 'We hope you enjoy this snack',
                                // Toast with icon
                                icon: (
                                    <View
                                        padding={12}
                                        backgroundColor="$gray100"
                                        borderRadius={8}
                                    >
                                        <Icon
                                            icon={FileStackIcon}
                                            size={24}
                                            color="$gray1200"
                                        />
                                    </View>
                                ),
                                duration: 10000,
                            });
                        }}
                    />
                    <TileButton
                        text="Show action toast"
                        icon={FileCogIcon}
                        onPress={() => {
                            toast.show('Toast is done!', {
                                // Toast with icon
                                description:
                                    'Your sandwich can be assembled now',
                                icon: (
                                    <View
                                        backgroundColor="$gray100"
                                        padding={8}
                                        borderRadius={4}
                                    >
                                        <Icon
                                            icon={FileCogIcon}
                                            size={20}
                                            color="$gray1200"
                                        />
                                    </View>
                                ),
                                button: (
                                    <Button
                                        variant={ButtonVariant.PRIMARY}
                                        size={ButtonSize.SMALL}
                                        text="Eat"
                                        onPress={() => {
                                            console.log('Yum!');
                                        }}
                                        buttonProps={{
                                            width: 'auto',
                                            paddingHorizontal: 20,
                                        }}
                                    />
                                ),
                                duration: 10000,
                            });
                        }}
                    />
                </XStack>
                <XStack gap={16} height={40}>
                    <TileButton
                        text="Long title"
                        onPress={() => {
                            toast.show(
                                'Cinnamon toast is the best kind of toast in the world',
                                {
                                    // Toast with icon
                                    icon: (
                                        <View
                                            padding={12}
                                            backgroundColor="$gray100"
                                            borderRadius={8}
                                        >
                                            <Icon
                                                icon={FileIcon}
                                                size={24}
                                                color="$gray1200"
                                            />
                                        </View>
                                    ),
                                    duration: 10000,
                                },
                            );
                        }}
                    />
                    <TileButton
                        text="Long subtitle"
                        onPress={() => {
                            toast.show('Cinnamon toast', {
                                description:
                                    'The best Ive ever had was from Trouble Coffee in San Francisco',
                                // Toast with icon
                                icon: (
                                    <View
                                        padding={12}
                                        backgroundColor="$gray100"
                                        borderRadius={8}
                                    >
                                        <Icon
                                            icon={FileBoxIcon}
                                            size={24}
                                            color="$gray1200"
                                        />
                                    </View>
                                ),
                                duration: 10000,
                            });
                        }}
                    />
                    <TileButton
                        text="Long both"
                        onPress={() => {
                            toast.show(
                                'Cinnamon toast is bread topped with butter, cinnamon, and sugar, toasted in an oven',
                                {
                                    description:
                                        'Be generous with toppings, with good bread and real butter! ',
                                    // Toast with icon
                                    icon: (
                                        <View
                                            padding={12}
                                            backgroundColor="$gray100"
                                            borderRadius={8}
                                        >
                                            <Icon
                                                icon={FileStackIcon}
                                                size={24}
                                                color="$gray1200"
                                            />
                                        </View>
                                    ),
                                    duration: 10000,
                                },
                            );
                        }}
                    />
                </XStack>
                <Button
                    text="Hide toast"
                    variant={ButtonVariant.SECONDARY}
                    tone="danger"
                    size={ButtonSize.SMALL}
                    onPress={() => {
                        toast.hide();
                    }}
                />
            </YStack>
        </YStack>
    );
};
